import type { CityConfig } from "../city-template/types";

export const battleCreekConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Calhoun County Clerk", href: "https://www.calhouncountymi.gov/clerk", description: "Calhoun County Clerk — marriage license issuance" },
    { label: "Divorce Records — Calhoun County Clerk", href: "https://www.calhouncountymi.gov/clerk", description: "Calhoun County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Battle Creek",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "battle-creek",
  route: "/cities/battle-creek",
  title: "Emergency Passport Battle Creek, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Battle Creek, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Battle Creek, Marshall, Albion, Springfield, and all Calhoun County residents. Kalamazoo/Battle Creek International Airport coverage. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Battle Creek, MI",
  heroSubtitle: "Battle Creek travelers — Calhoun County residents, Kellogg Company employees, W.K. Kellogg Airport flyers, and international families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Calhoun County and Southwest Michigan.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20Battle%20Creek%20Michigan%20downtown%20skyline%20with%20historic%20buildings%2C%20Michigan%20Avenue%2C%20lush%20green%20trees%2C%20Calhoun%20County%20landscape%2C%20warm%20golden%20hour%20light%2C%20clear%20blue%20sky%2C%20no%20text%20no%20people%2C%20cinematic%20landscape%20photography&width=1800&height=700&seq=battlecreek-hero-001&orientation=landscape",
  heroImageAlt: "Battle Creek Michigan downtown skyline along Michigan Avenue at golden hour",
  geoPosition: "42.3212;-85.1797",
  geoPlacename: "Battle Creek, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 115 miles east of Battle Creek — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Battle Creek", zips: "49014, 49015, 49016, 49017, 49018, 49037" },
    { name: "Marshall", zips: "49068, 49069" },
    { name: "Albion", zips: "49224" },
    { name: "Springfield", zips: "49015, 49037" },
    { name: "Athens", zips: "49011" },
    { name: "Climax", zips: "49034" },
    { name: "East Leroy", zips: "49051" },
    { name: "Burlington", zips: "49029" },
    { name: "Tekonsha", zips: "49092" },
    { name: "Union City", zips: "49094" },
    { name: "Ceresco", zips: "49033" },
    { name: "Homer", zips: "49245" },
    { name: "Bellevue", zips: "49021" },
    { name: " Augusta", zips: "49012" },
    { name: "Kalamazoo", zips: "49001, 49004, 49006, 49007, 49008, 49009" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "Southwest Michigan Expertise", desc: "Kalamazoo/Battle Creek International Airport and cross-border travel passport support" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from anywhere in Calhoun County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Kalamazoo, MI", route: "/cities/kalamazoo" },
    { name: "Emergency passport services in Jackson, MI", route: "/cities/jackson-mi" },
    { name: "Urgent passport services in Lansing, MI", route: "/lansing-mi" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Battle Creek, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the 115-mile drive or appointment wait. Battle Creek residents can ship from any UPS or FedEx in Calhoun County.",
  fpcOfficeDistance: "Serving Battle Creek, Marshall, Albion, Springfield, Athens, Climax, East Leroy, and all of Calhoun County and Southwest Michigan",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Battle Creek and the greater Calhoun County region. From the downtown Michigan Avenue corridor to the Fort Custer Recreation Area, from Marshall to Albion — we serve all of the Southwest Michigan corridor. The Detroit Passport Agency is approximately 115 miles east, and our couriers have direct access to it.",
  nearbyCitiesIntro: "We serve Battle Creek and all Calhoun County communities including Marshall, Albion, Springfield, Athens, Climax, East Leroy, Burlington, Tekonsha, Union City, Ceresco, Homer, Bellevue, and Augusta. We also serve Southwest Michigan travelers and Kalamazoo/Battle Creek International Airport flyers.",
  howItWorksIntro: "Most Battle Creek travelers complete everything online and ship documents overnight. No driving 115 miles to the Detroit Passport Agency or waiting weeks for an appointment — our registered couriers handle the submission for you.",
  mistakesIntro: "Battle Creek is a unique Southwest Michigan community with heavy Kellogg Company and Denso international travel, Fort Custer Recreation Area tourism, and cross-border family visits. Here are the most common passport mistakes we see from Calhoun County travelers.",
  testimonialsIntro: "Battle Creek travelers — from Kalamazoo/Battle Creek International Airport flyers to Fort Custer outdoor enthusiasts to international families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Battle Creek, MI? Here are the most common ones we hear from Calhoun County and Southwest Michigan travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for AZO Airport and Southwest Michigan travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person in Detroit — 115-mile drive", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Battle Creek travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute Kalamazoo/Battle Creek International Airport flights, family emergencies, and business travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "AZO Airport and Southwest Michigan travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Battle Creek adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Calhoun County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Battle Creek residents and families — including international students, new citizens, and Calhoun County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Battle Creek residents who lost their passport before international travel or AZO Airport departure.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Battle Creek-area families planning international vacations, Fort Custer trips, or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Battle Creek and Calhoun County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Battle Creek MI", description: "Urgent passport processing for Battle Creek Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Battle Creek MI", description: "Fast passport renewal for Battle Creek Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Battle Creek MI", description: "New passport application services for Battle Creek Michigan residents applying for their first passport." },
    { name: "Child Passport Battle Creek MI", description: "Minor passport services for Battle Creek Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Battle Creek, MI",
      rating: 5,
      text: "Flying to London for a Kellogg business conference in 4 days and my passport was expired. Fast Passport Center saved the trip — renewed in 3 days. I shipped from the UPS Store on Columbia Avenue and had it back before I even packed.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Robert K.",
      location: "Marshall, MI",
      rating: 5,
      text: "Family cruise to the Caribbean in 6 days and my daughter's passport was lost. Fast Passport Center had a replacement in our hands in 48 hours. No driving to Detroit, no appointment wait. Their courier service is a lifesaver for Calhoun County.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Amanda T.",
      location: "Albion, MI",
      rating: 5,
      text: "Study abroad trip to Spain with 8 days notice. Fast Passport Center processed my first-time passport in 4 days. They caught a mistake on my application that would have delayed me.",
      service: "First-Time Passport",
    },
    {
      name: "David M.",
      location: "Battle Creek, MI",
      rating: 5,
      text: "Business trip to Germany and I realized my passport was expiring too soon. Fast Passport Center got me a renewed passport in 2 days. I shipped from the FedEx in Battle Creek and everything was seamless.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "bc-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 115 miles east of Battle Creek — appointments typically booked 2 weeks out",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "bc-2",
      name: "Battle Creek Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 164 Michigan Ave",
      city: "Battle Creek",
      state: "MI",
      zip: "49014",
      phone: "(269) 968-4897",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Battle Creek — near the Michigan Avenue corridor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Battle Creek acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Battle Creek and the Michigan Avenue corridor residents.",
      icon: "ri-mail-line",
    },
    {
      id: "bc-3",
      name: "Lakeview Square Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 5700 Beckley Rd",
      city: "Battle Creek",
      state: "MI",
      zip: "49015",
      phone: "(269) 979-1521",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Battle Creek — near Lakeview Square Mall",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves south Battle Creek and Lakeview area residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "bc-4",
      name: "Marshall Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 202 W. Michigan Ave",
      city: "Marshall",
      state: "MI",
      zip: "49068",
      phone: "(269) 781-7101",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Marshall — approximately 15 miles east of Battle Creek",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Marshall and eastern Calhoun County residents. Historic downtown Marshall location.",
      icon: "ri-mail-line",
    },
    {
      id: "bc-5",
      name: "Albion Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 106 S. Superior St",
      city: "Albion",
      state: "MI",
      zip: "49224",
      phone: "(517) 629-3841",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Albion — approximately 20 miles south of Battle Creek",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Albion and southern Calhoun County residents. Near Albion College campus.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Calhoun County" },
    { feature: "AZO Airport & Southwest Michigan Expertise", agency: "No tailored advice", fpc: "Yes — Kalamazoo/Battle Creek International Airport and Southwest Michigan travel" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Battle Creek and Calhoun County travelers often discover passport issues right before AZO Airport departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for International Air Travel",
      description: "Some Battle Creek-area travelers assume a passport card is sufficient for all travel — but passport cards are only valid for land and sea border crossings. All international flights require a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Calhoun County acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Kalamazoo/Battle Creek International Airport Flight Requirements",
      description: "Kalamazoo/Battle Creek International Airport (AZO) has limited international flight options. Many Battle Creek travelers connect through DTW or Chicago O'Hare. Verify passport requirements for all connecting airports.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Calhoun County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Battle Creek, Marshall, or Albion." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no 115-mile drive or appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Calhoun County address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport agency to Battle Creek, MI?", a: "The Detroit Passport Agency is the nearest regional passport agency to Battle Creek, located at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 115 miles east. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access and can submit applications without individual appointments, saving you the long drive and wait." },
    { q: "How fast can I get an emergency passport in Battle Creek?", a: "Fast Passport Center offers emergency passport processing in Battle Creek, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to drive 115 miles east or take a day off work." },
    { q: "Do I need a passport for international flights from Kalamazoo/Battle Creek International Airport?", a: "Yes. All international flights from Kalamazoo/Battle Creek International Airport (AZO) require a passport book. While AZO primarily serves domestic destinations, many Battle Creek travelers connect through Detroit Metro (DTW) or Chicago O'Hare for international flights. A passport book is required for all international air travel regardless of your departure airport." },
    { q: "Can I get an expedited passport in the Battle Creek suburbs like Marshall or Albion?", a: "Absolutely. Fast Passport Center serves all of Calhoun County including Marshall, Albion, Springfield, Athens, Climax, East Leroy, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Battle Creek-area travelers use for international flights?", a: "Kalamazoo/Battle Creek International Airport (AZO) in Portage is the local airport for Battle Creek and Kalamazoo — primarily domestic flights. Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international departure hub — approximately 115 miles east. Many Battle Creek travelers also use Chicago O'Hare (ORD) for international connections. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Battle Creek, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Battle Creek-area residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Battle Creek, Marshall, and Albion offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve the Upper Peninsula from Battle Creek?", a: "Yes. Fast Passport Center serves all of Michigan including the Upper Peninsula. Our courier service is especially valuable for remote UP communities, which would otherwise face an 8+ hour drive to the Detroit Passport Agency. We serve Marquette, Sault Ste. Marie, Houghton, Escanaba, and all UP communities — you just ship your documents overnight and we handle everything from there." },
  ],
  photoLocations: [
    { name: "Walgreens — Beckley Road", address: "5425 Beckley Rd, Battle Creek, MI 49015", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Battle Creek", address: " 599 Columbia Ave, Battle Creek, MI 49015", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Battle Creek", address: " 5782 B Dr N, Battle Creek, MI 49014", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Marshall", address: " 202 W. Michigan Ave, Marshall, MI 49068", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Battle Creek", address: " 5700 Beckley Rd, Battle Creek, MI 49015", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Serves Battle Creek, Lakeview, and central Calhoun County. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Marshall", address: " 202 W. Michigan Ave, Marshall, MI 49068", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Marshall, Albion, and eastern Calhoun County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "AZO",
      name: "Kalamazoo/Battle Creek International Airport",
      distance: "Located in Portage — approximately 25 miles northwest of Battle Creek",
      address: "5235 Portage Rd, Portage, MI 49002",
      note: "Regional airport serving Battle Creek and Kalamazoo. Primarily domestic flights with connections to major hubs. Delta, American, and United service. Not a major international gateway — most Battle Creek international travelers connect through DTW or Chicago O'Hare.",
      flightUrl: "https://www.azooairport.com/",
      flightLabel: "AZO Airport Info",
      featured: false,
    },
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "Approximately 115 miles east of Battle Creek via I-94",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for Southwest Michigan. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan. Most Battle Creek international travelers connect through DTW.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
  ],
};